import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { InstantMessageListItems } from "ui/Scripts/source/models/instantMessage/instantMessageListItems";
import { getApiCall, postApiCall } from "./tokenService";
import { InstantMessagePage } from "../instantMessage/instantMessagePage";
import { CompanyListItems } from "../company/companyListItems";
import { InstantMessagePermission } from "../instantMessage/instantMessagePermission";

// #region InstantMessagePage
export const getInstantMessagePage = (): Promise<InstantMessagePage> => {
    return getApiCall("api/instantmessage", InstantMessagePage);
};

export const getInstantMessageListItems = (companyId: string, channelId: string, pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<InstantMessageListItems> => {
    return postApiCall("api/instantmessage/list", InstantMessageListItems, JSON.stringify({
        companyId,
        channelId,
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || ""
    }));
};

export const saveInstantMessage = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/instantmessage/save", SaveSuccess, JSON.stringify(obj));
};

export const removeInstantMessage = (id: string): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessage/remove?id=" + id, ApiSuccess);
};

export const restoreInstantMessage = (id: string): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessage/restore?id=" + id, ApiSuccess);
};

export const sendInstantMessageReadReceipts = (ids: string[]): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessage/sendreadreceipts", ApiSuccess, JSON.stringify(ids));
};
// #endregion InstantMessagePage

// #region Partners
export const getInstantMessagePartners = (companyId: string): Promise<CompanyListItems> => {
    return getApiCall("api/instantmessage/module/partners?id=" + companyId, CompanyListItems);
};

export const removeInstantMessagePartners = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessage/module/removepartners", ApiSuccess, JSON.stringify(obj));
};

export const addInstantMessagePartners = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessage/module/addpartners", ApiSuccess, JSON.stringify(obj));
};

export const getInstantMessageCompanyListItems = (pageSize: number, page: number, filter: string, companyGroupIds: string[], activityState: number, sortColumn: string, sortOrderIsAsc: boolean, ignoreCompanyGroupId: string, ignoreCompanyIds: string[]): Promise<CompanyListItems> => {
    return postApiCall("api/instantmessage/module/selectpartnercompanieslist", CompanyListItems, JSON.stringify({
        pageSize,
        page,
        sortColumn,
        sortOrder: sortOrderIsAsc ? "asc" : "desc",
        filter: filter || "",
        companyGroupIds,
        activityState,
        ignoreCompanyGroupId,
        ignoreCompanyIds
    }));
};
// #endregion Partners

// #region Permissions
export const getInstantMessagePermissions = (companyId: string): Promise<InstantMessagePermission> => {
    return getApiCall("api/instantmessage/module/permissions?id=" + companyId, InstantMessagePermission);
};

export const saveUnitNodePermissions = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/instantmessage/module/savepermissions", ApiSuccess, JSON.stringify(obj));
};
// #endregion Permissions
